<div class="cont-footer">
  <div class="copyright"><div>Leapmotor España {{ currentYear }}</div> <a href="mailto:leapmotor@apoyored.es">leapmotor&#64;apoyored.es</a></div>
  <div class="legal-options">
    <a [href]="legal.FileUri" target="_blank">Aviso legal</a>
  </div>
</div>